import {ff, form, FormBody} from "@mc/mc-legacy";
import {Col} from "@mc/ui-v3";
import React from "react";
import {connect} from "react-redux";
import {Button} from "reactstrap";
import {reduxForm} from "redux-form";

const validate = (formData) => {
    return {};
};

interface PodpisFormProps {
    fonts: []
}

class PodpisForm extends React.Component<PodpisFormProps> {
    static formName = "PodpisForm";

    constructor(props) {
        super(props);
        this.state = {fonts: []};
    }

    render() {
        const {handleSubmit, submitting, fonts} = this.props;

        return (
            <div className="w-100 d-flex justify-content-center">
                <Col xs={5} className="d-flex mt-2">
                    <form>
                        <FormBody>
                            <ff.Checkbox
                                label={false}
                                checkboxLabel="Používat vlastní konfiguraci"
                                name="customSignEnabled"
                                disabled={submitting}
                            />
                            <ff.Select disabled={submitting} name="fontFile" label="Font" items={fonts}>
                                {fonts.map(v => (
                                    <option value={v} key={v}>
                                        {v}
                                    </option>
                                ))}
                            </ff.Select>
                            <ff.String disabled={submitting} name="iconFile" label="Cesta k ikoně"/>
                            <ff.Checkbox
                                label={false}
                                checkboxLabel="Vložit rámeček"
                                name="insertBorder"
                                disabled={submitting}
                            />
                            <ff.Checkbox
                                label={false}
                                checkboxLabel="Zobrazovat info ve vizualizaci"
                                name="insertInfo"
                                disabled={submitting}
                            />
                            <ff.Checkbox
                                label={false}
                                checkboxLabel="Zobrazovat popis podepisující osoby ve vizualizaci"
                                name="insertDescription"
                                disabled={submitting}
                            />
                            <Button color="primary" className="mt-4" onClick={handleSubmit}>
                                Aktualizovat
                            </Button>
                        </FormBody>
                    </form>
                </Col>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(
    reduxForm({
        initialValues: {},
        form: PodpisForm.formName,
        validate: validate,
    })(PodpisForm)
);
